
























import { Component, Vue, Emit } from 'vue-property-decorator'
import { AddDrugBatch} from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import constant from '@/utils/constant'
import { timeFormate } from '@/utils/date/DateUtil'
import { getRole } from '@/store/userStore'

@Component({
  components: {
  },
})
export default class CreatePlatformDialog extends Vue {
  private constant = constant
  private show = false
  private data: any = {batchNum:"",price:0}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    batchNum: [this.requiredRule],
    validity: [this.requiredRule],
    prodDate: [this.requiredRule],
    stock: [this.requiredRule],
  }

  private get role() {
    return getRole();
  }

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
      this.data = {batchNum:"",price:0}
    }
  public open(param: any) {
    this.show = true
    this.data.supplierId = param.supplierId
    this.data.drugCode = param.drugCode
    this.data.drugName = param.drugName
    this.data.price = param.suppliyPrice
    const d = new Date()
    // this.data.batchNum = "B"+timeFormate(new Date(),"YYMMDDHHmmss")
    
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      await AddDrugBatch(this.data)
      Message.success('保存成功')
      this.close()
    })
  }
}
